/**
 * eventsProvider — unified events search provider.
 *
 * Merges all event types (church, field, personal) into a single
 * searchable collection. Events are the first provider to aggregate
 * multiple sub-types — pattern ready for future composite providers.
 *
 * Indexed fields: title, event_type
 * Future: location, description, participants
 */

import { CalendarDays } from "lucide-react";
import {
  getChurchEventsByDistrict,
  getFieldEvents,
  getPersonalEvents,
} from "@/lib/api";
import { formatSmartDate } from "@/lib/date";

const eventsProvider = {
  id: "eventos",
  label: "Eventos",
  icon: CalendarDays,
  iconBg: "bg-amber-50",
  iconColor: "text-amber-600",
  fields: ["title", "event_type"],
  load: async (districtId) => {
    const [churchRes, fieldRes, personalRes] = await Promise.allSettled([
      getChurchEventsByDistrict({ district_id: districtId }),
      getFieldEvents({ district_id: districtId }),
      getPersonalEvents({ district_id: districtId }),
    ]);
    return [
      ...(churchRes.status   === "fulfilled" ? churchRes.value   || [] : []),
      ...(fieldRes.status    === "fulfilled" ? fieldRes.value    || [] : []),
      ...(personalRes.status === "fulfilled" ? personalRes.value || [] : []),
    ];
  },
  buildItem: (e) => ({
    id: e.id,
    title: e.title,
    subtitle: formatSmartDate(e.date || e.start_date),
    route: `/agenda`,
    recent: null,
  }),
};

export default eventsProvider;
